<div class="container mx-auto px-4 h-full">
  <div class="flex content-center items-center justify-center h-full">
    <div class="w-full md:w-6/12 px-4">
      <div class="relative flex justify-center">
        <img class="w-4/12 mb-4" src="assets/brand/atc_full_whiteOnTransparent.png" />
      </div>

      <!-- Completing Google/Apple redirect sign-in -->
      <div *ngIf="isCompletingSocialLogin && authMode !== 'forgotPassword'"
        class="relative flex flex-col items-center min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0 px-6 py-10">
        <i class="fas fa-circle-notch fa-spin text-2xl text-blueGray-500 mb-3"></i>
        <h6 class="text-blueGray-500 text-sm font-bold">Signing you in…</h6>
      </div>

      <!-- Sign In Card -->
      <div *ngIf="authMode === 'login' && !isCompletingSocialLogin"
        class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
        <div class="rounded-t mb-0 px-6 py-6">
          <div class="text-center">
            <h6 class="text-blueGray-500 text-sm font-bold">Sign In with Credentials</h6>
          </div>
        </div>
        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form [formGroup]="loginForm" (ngSubmit)="emailLogin()">
            <!-- Top of card error alert -->
            <div *ngIf="error"
              class="mb-4 text-xs bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative flex flex-row items-start gap-2"
              role="alert">
              <i class="fas fa-exclamation-circle text-sm shrink-0 self-start mt-0.5"></i>
              <span class="flex-1 leading-normal self-start">{{ error.toString() }}</span>
              <button type="button" (click)="error = null" class="text-red-700 hover:text-red-900 font-bold ml-2 self-start leading-none cursor-pointer">
                &times;
              </button>
            </div>

            <div class="w-full mb-1">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="username">
                Email
              </label>
              <input type="email" formControlName="username" id="username" name="username" autocomplete="username"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Email">
              <div
                class="{{ loginForm.get('username')?.invalid && (loginForm.get('username')?.dirty || loginForm.get('username')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                <p *ngIf="loginForm.get('username')?.errors?.['required']">
                  Username (email) is required.
                </p>
                <p *ngIf="loginForm.get('username')?.errors?.['email']">
                  Please enter a valid email address.
                </p>
              </div>
            </div>
            <div class="w-full mb-1">
              <div class="flex justify-between items-center mb-1">
                <label for="password" class="block uppercase text-blueGray-600 text-xs font-bold">
                  Password
                </label>
                <a (click)="showForgotPassword()" class="text-xs text-primary-500 hover:text-primary-700 cursor-pointer font-semibold">
                  Forgot password?
                </a>
              </div>
              <input type="password" formControlName="password" id="password" name="password" autocomplete="off"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Password" />
              <div
                class="{{ loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                <div *ngIf="loginForm.get('password')?.errors?.['required']">
                  Password is required.
                </div>
              </div>
            </div>
            <div class="text-center mt-2">
              <button type="submit" [disabled]="!loginForm.valid" class="bg-primary-500 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded
                shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all
                duration-150 disabled:opacity-50 disabled:cursor-not-allowed">
                Sign In
              </button>
            </div>
          </form>

          <div class="text-blueGray-400 text-center mt-4 font-bold">
            <small>Or Sign In with</small>
          </div>

          <hr class="my-4 border-b border-blueGray-300" />
          <p *ngIf="isInAppBrowser" class="mb-3 text-xs text-center text-blueGray-600">
            Google sign-in doesn't work inside this app's browser. Open this page in Chrome or Safari
            (use the &#8942; or share menu, then "Open in browser").
          </p>
          <div class="social-buttons flex flex-row gap-2 justify-center items-center">
            <button (click)="_socialLogin(provider.google)" aria-label="Sign in with Google"
              class="flex-1 max-w-52 h-10 justify-center bg-white active:bg-blueGray-50 text-blueGray-700 px-4 rounded outline-none focus:outline-none shadow hover:shadow-lg inline-flex items-center font-bold text-xs ease-linear transition-all duration-150"
              type="button">
              <img alt="" class="w-5 mr-2" src="assets/img/google.svg" />
              <span class="whitespace-nowrap"><span class="sign-in-prefix">Sign in with </span>Google</span>
            </button>
            <button (click)="_socialLogin(provider.apple)" aria-label="Sign in with Apple"
              class="flex-1 max-w-52 h-10 justify-center bg-black active:bg-blueGray-800 text-white px-4 rounded outline-none focus:outline-none shadow hover:shadow-lg inline-flex items-center font-bold text-xs ease-linear transition-all duration-150"
              type="button">
              <i class="fab fa-apple text-base leading-none mr-2"></i>
              <span class="whitespace-nowrap"><span class="sign-in-prefix">Sign in with </span>Apple</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Register Card -->
      <div *ngIf="authMode === 'register' && !isCompletingSocialLogin"
        class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
        <div class="rounded-t mb-0 px-6 py-6">
          <div class="text-center">
            <h6 class="text-blueGray-500 text-sm font-bold">Register New Account</h6>
          </div>
        </div>
        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form [formGroup]="registerForm" (ngSubmit)="signUp()">
            <!-- Top of card error alert -->
            <div *ngIf="error"
              class="mb-4 text-xs bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative flex flex-row items-start gap-2"
              role="alert">
              <i class="fas fa-exclamation-circle text-sm shrink-0 self-start mt-0.5"></i>
              <span class="flex-1 leading-normal self-start">{{ error.toString() }}</span>
              <button type="button" (click)="error = null" class="text-red-700 hover:text-red-900 font-bold ml-2 self-start leading-none cursor-pointer">
                &times;
              </button>
            </div>

            <div class="w-full mb-2">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="reg-username">
                Email
              </label>
              <input type="email" formControlName="username" id="reg-username" name="username" autocomplete="username"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Email">
              <div
                class="{{ registerForm.get('username')?.invalid && (registerForm.get('username')?.dirty || registerForm.get('username')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                <p *ngIf="registerForm.get('username')?.errors?.['required']">
                  Username (email) is required.
                </p>
                <p *ngIf="registerForm.get('username')?.errors?.['email']">
                  Please enter a valid email address.
                </p>
              </div>
            </div>
            <div class="w-full mb-1">
              <label for="reg-password" class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                Password
              </label>
              <input type="password" formControlName="password" id="reg-password" name="password"
                autocomplete="new-password"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Password" />
              <div
                class="{{ registerForm.get('password')?.invalid && (registerForm.get('password')?.dirty || registerForm.get('password')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                <div *ngIf="registerForm.get('password')?.errors?.['required']">
                  Password is required.
                </div>
              </div>
            </div>
            <div class="w-full mb-1">
              <label for="confirmPassword" class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                Confirm Password
              </label>
              <input type="password" formControlName="confirmPassword" id="confirmPassword" name="confirmPassword"
                autocomplete="confirm-new-password"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Re-type Password" />
              <div
                class="{{ registerForm.get('confirmPassword')?.invalid && (registerForm.get('confirmPassword')?.dirty || registerForm.get('confirmPassword')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                <div *ngIf="registerForm.get('confirmPassword')?.errors?.['required']">
                  Password is required.
                </div>
                <div *ngIf="registerForm.get('confirmPassword')?.errors?.['matching']">
                  Passwords not matching.
                </div>
              </div>
            </div>
            <div class="text-center mt-2">
              <button type="submit" [disabled]="!registerForm.valid" class="bg-primary-500 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded
                shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all
                duration-150 disabled:opacity-50 disabled:cursor-not-allowed">
                Create Account
              </button>
            </div>
          </form>

          <div class="text-blueGray-400 text-center mt-4 font-bold">
            <small>Or Sign In with</small>
          </div>

          <hr class="my-4 border-b border-blueGray-300" />
          <p *ngIf="isInAppBrowser" class="mb-3 text-xs text-center text-blueGray-600">
            Google sign-in doesn't work inside this app's browser. Open this page in Chrome or Safari
            (use the &#8942; or share menu, then "Open in browser").
          </p>
          <div class="social-buttons flex flex-row gap-2 justify-center items-center">
            <button (click)="_socialLogin(provider.google)" aria-label="Sign in with Google"
              class="flex-1 max-w-52 h-10 justify-center bg-white active:bg-blueGray-50 text-blueGray-700 px-4 rounded outline-none focus:outline-none shadow hover:shadow-lg inline-flex items-center font-bold text-xs ease-linear transition-all duration-150"
              type="button">
              <img alt="" class="w-5 mr-2" src="assets/img/google.svg" />
              <span class="whitespace-nowrap"><span class="sign-in-prefix">Sign in with </span>Google</span>
            </button>
            <button (click)="_socialLogin(provider.apple)" aria-label="Sign in with Apple"
              class="flex-1 max-w-52 h-10 justify-center bg-black active:bg-blueGray-800 text-white px-4 rounded outline-none focus:outline-none shadow hover:shadow-lg inline-flex items-center font-bold text-xs ease-linear transition-all duration-150"
              type="button">
              <i class="fab fa-apple text-base leading-none mr-2"></i>
              <span class="whitespace-nowrap"><span class="sign-in-prefix">Sign in with </span>Apple</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Reset Password Card -->
      <div *ngIf="authMode === 'forgotPassword'"
        class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
        <div class="rounded-t mb-0 px-6 py-6">
          <div class="text-center">
            <h6 class="text-blueGray-500 text-sm font-bold">Reset Password</h6>
          </div>
        </div>
        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
          <!-- Top of card error alert -->
          <div *ngIf="error"
            class="mb-4 text-xs bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative flex flex-row items-start gap-2"
            role="alert">
            <i class="fas fa-exclamation-circle text-sm shrink-0 self-start mt-0.5"></i>
            <span class="flex-1 leading-normal self-start">{{ error.toString() }}</span>
            <button type="button" (click)="error = null" class="text-red-700 hover:text-red-900 font-bold ml-2 self-start leading-none cursor-pointer">
              &times;
            </button>
          </div>

          <!-- Email Sent Confirmation View -->
          <div *ngIf="resetEmailSent; else resetFormTpl" class="text-center py-2">
            <div class="w-14 h-14 mx-auto rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mb-4">
              <i class="fas fa-paper-plane text-xl"></i>
            </div>
            <h5 class="text-base font-bold text-blueGray-700 mb-2">Password Reset Link Sent</h5>
            <p class="text-xs text-blueGray-600 mb-6 leading-relaxed">
              We've sent an email to <strong class="text-blueGray-800">{{ resetSentEmail }}</strong>. Follow the instructions in the email to reset your password.
            </p>
            <div class="flex flex-col gap-3">
              <button type="button" (click)="resendResetEmail()" [disabled]="isResetSubmitting"
                class="text-xs text-primary-500 hover:text-primary-700 font-semibold uppercase underline cursor-pointer disabled:opacity-50">
                <span *ngIf="isResetSubmitting"><i class="fas fa-spinner fa-spin mr-1"></i> Resending...</span>
                <span *ngIf="!isResetSubmitting">Didn't receive email? Click to resend</span>
              </button>
              <button (click)="showLogin()" type="button"
                class="bg-primary-500 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none w-full ease-linear transition-all duration-150">
                Return to Sign In
              </button>
            </div>
          </div>

          <!-- Reset Password Request Form -->
          <ng-template #resetFormTpl>
            <p class="text-xs text-blueGray-500 text-center mb-6">
              Enter your registered email address and we'll send you a link to reset your password.
            </p>
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="sendPasswordReset()">
              <div class="w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="resetEmail">
                  Email
                </label>
                <input type="email" formControlName="email" id="resetEmail" name="resetEmail" autocomplete="email"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Email">
                <div
                  class="{{ forgotPasswordForm.get('email')?.invalid && (forgotPasswordForm.get('email')?.dirty || forgotPasswordForm.get('email')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                  <p *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">
                    Email is required.
                  </p>
                  <p *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">
                    Please enter a valid email address.
                  </p>
                </div>
              </div>
              <div class="text-center mt-2">
                <button type="submit" [disabled]="!forgotPasswordForm.valid || isResetSubmitting" class="bg-primary-500 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded
                  shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all
                  duration-150 disabled:opacity-50 disabled:cursor-not-allowed">
                  <span *ngIf="isResetSubmitting" class="inline-flex items-center justify-center">
                    <i class="fas fa-spinner fa-spin mr-2"></i> Sending...
                  </span>
                  <span *ngIf="!isResetSubmitting">Send Reset Link</span>
                </button>
              </div>
            </form>
          </ng-template>
        </div>
      </div>

      <!-- Navigation links below the card -->
      <div class="flex flex-wrap justify-between items-center mt-2 relative">
        <div class="w-1/2">
          <a *ngIf="authMode === 'forgotPassword'" (click)="showLogin()" class="cursor-pointer text-blueGray-200 hover:text-white">
            <small><i class="fas fa-arrow-left mr-1"></i>Back to Sign In</small>
          </a>
        </div>
        <div class="w-1/2 text-right">
          <a *ngIf="authMode === 'login'" (click)="showRegister()" class="cursor-pointer text-blueGray-200 hover:text-white">
            <small>Register New Account</small>
          </a>
          <a *ngIf="authMode === 'register'" (click)="showLogin()" class="cursor-pointer text-blueGray-200 hover:text-white">
            <small>Already have an account? <span class="font-bold underline">Sign In</span></small>
          </a>
          <a *ngIf="authMode === 'forgotPassword'" (click)="showRegister()" class="cursor-pointer text-blueGray-200 hover:text-white">
            <small>Register New Account</small>
          </a>
        </div>
      </div>

      <a href="https://mustardlabs.net" target="_blank" rel="noopener"
        class="relative flex items-center justify-center gap-2 mt-10 text-xs text-blueGray-200 hover:text-white">
        Powered by
        <img src="assets/brand/mustardlabs-logo-white.svg" alt="Mustard Labs" class="h-4 w-auto" />
      </a>
    </div>
  </div>
</div>